import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "not_ok_icon--sprite",
  "use": "not_ok_icon--sprite-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol viewBox=\"0 0 13 14\" stroke=\"#B7B7B7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"not_ok_icon--sprite\">\n    <path d=\"M13 13L7 7M7 7L13 1M7 7L1 13M7 7L1 1\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol